<template>
  <div class="container">
    <!-- header -->
    <div class="header">
      <div class="head_warp">
        <div class="head_title">心理健康教育平台</div>
      </div>
    </div>
    <!-- content -->
    <div class="content" style="overflow: auto">
      <!--  -->
      <div class="warp" style="height: calc(100vh - 140px)">
        <!-- text -->
        <div class="back-head">
          <h3>学生注册</h3>
          <p>请选择您的学校班级并输入您的基本信息。</p>
        </div>
        <!-- 基本信息验证 -->
        <el-form
          ref="ruleForm"
          :model="form"
          label-width="100px"
          :rules="formRules"
        >
          <!-- 所在地区 -->
          <el-form-item label="所在地区：" prop="province">
            <div class="area_list">
              <el-select
                v-model="form.province"
                placeholder="请选择省份"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.area_id"
                  :label="item.area_name"
                  :value="item.area_id"
                ></el-option>
              </el-select>
              <el-select
                v-model="form.city"
                placeholder="请选择城市"
                style="margin: 0 10px"
                @change="cityChange"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.area_id"
                  :label="item.area_name"
                  :value="item.area_id"
                ></el-option>
              </el-select>
              <el-select
                v-model="form.county"
                placeholder="请选择区县"
                @change="countyChange"
              >
                <el-option
                  v-for="item in countyList"
                  :key="item.area_id"
                  :label="item.area_name"
                  :value="item.area_id"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 年级班级 -->
          <el-form-item label="学校：" prop="school_id">
            <div class="class_warp">
              <el-select
                v-model="form.school_id"
                placeholder="请选择学校"
                @change="schoolChange"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.school_id"
                  :label="item.school_name"
                  :value="item.school_id"
                ></el-option>
              </el-select>
              <el-select
                style="margin: 0 10px"
                v-model="form.grade_id"
                placeholder="请选择年级"
                @change="gradeChange"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.grade_id"
                  :label="item.grade_name"
                  :value="item.grade_id"
                ></el-option>
              </el-select>
              <el-select v-model="form.class_id" placeholder="请选择班级">
                <el-option
                  v-for="item in classList"
                  :key="item.class_id"
                  :label="item.class_name"
                  :value="item.class_id"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 基本个人信息 -->
          <!-- 姓名 -->
          <el-form-item label="姓名：" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入姓名"
              style="width: 675px"
            ></el-input>
          </el-form-item>
          <!-- 身份证 -->
          <!--身份证号性别-->
          <div class="idcard_list">
            <el-form-item label="身份证号：" prop="idcard">
              <el-input
                v-model="form.idcard"
                style="width: 280px"
                placeholder="请输入身份证"
              ></el-input>
            </el-form-item>

            <el-form-item label="性别：" prop="sex">
              <el-select v-model="form.sex" style="width: 290px">
                <el-option
                  v-for="item in genderList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 年龄出生日期 -->
          <div class="idcard_list">
            <el-form-item label="年龄：" prop="age">
              <el-input-number
                style="width: 280px"
                v-model="form.age"
                :min="0"
                :max="1000"
                label
              ></el-input-number>
            </el-form-item>
            <el-form-item label="出生日期：" prop="birthday">
              <el-date-picker
                style="width: 290px"
                v-model="form.birthday"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </div>
          <!-- 联系方式 -->
          <el-form-item label="联系方式：">
            <el-input
              v-model="form.contact"
              placeholder="请输入联系方式"
              style="width: 675px"
            ></el-input>
          </el-form-item>
          <!-- 家庭住址 -->
          <el-form-item label="家庭住址：">
            <el-input
              v-model="form.address"
              placeholder="请输入家庭地址"
              style="width: 675px"
            ></el-input>
          </el-form-item>

          <!-- 账号密码 -->
          <div class="idcard_list">
            <el-form-item label="账号：" prop="login_name">
              <el-input
                v-model="form.login_name"
                style="width: 280px"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input
                v-model="form.password"
                :type="passwordFlag ? 'text' : 'password'"
                placeholder="请输入密码"
                style="width: 290px"
              >
                <i
                  slot="suffix"
                  :class="[passwordFlag ? 'el-icon-minus' : 'el-icon-view']"
                  style="margin-top: 8px; font-size: 18px"
                  autocomplete="auto"
                  @click="passwordFlag = !passwordFlag"
                />
              </el-input>
            </el-form-item>
          </div>
          <!-- 确认密码 -->
          <el-form-item label="确认密码：" prop="password_again">
            <el-input
              v-model="form.password_again"
              :type="passwordAgainFlag ? 'text' : 'password'"
              placeholder="请再次输入密码"
              style="width: 280px"
            >
              <i
                slot="suffix"
                :class="[passwordAgainFlag ? 'el-icon-minus' : 'el-icon-view']"
                style="margin-top: 8px; font-size: 18px"
                autocomplete="auto"
                @click="passwordAgainFlag = !passwordAgainFlag"
              />
            </el-input>
          </el-form-item>
          <!--  -->
        </el-form>
        <!-- 协议 -->
        <div class="checked-box">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="agreementText" @click="dialogVisible = true"
            >我已阅读并同意此协议</span
          >
        </div>

        <!-- 注册按钮 -->
        <div class="next">
          <el-button
            type="primary"
            class="next_btn"
            @click="registerUser('ruleForm')"
            >注册</el-button
          >
        </div>
      </div>
    </div>
    <!-- line -->
    <div class="footer_line"></div>
    <!--footer-->
    <div class="footer">
      <p>
        <a target="_bank" href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          >四川蓝韵心理咨询服务有限公司</a
        >
      </p>
    </div>
    <!-- 弹框 -->
    <div>
      <el-dialog title="用户协议" :visible.sync="dialogVisible" width="55%">
        <div>
          <iframe
            src="/static/html/agreement.html"
            style="width: 100%; height: 600px"
          ></iframe>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    /* 验证身份证号码 */
    var validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入身份证号码"));
      }
      if (!LYCom.IdentityCodeValid(value)) {
        callback(new Error("身份证号码不正确"));
      } else {
        //生成出生日期
        this.form.birthday = LYCom.GetBirthdayByIdCard(value);
        //年龄
        this.form.age = LYCom.GetAgeByIdCard(value);
        //性别
        this.form.sex = LYCom.GetSexByIdCard(value);
        callback();
      }
    };
    /* 触发密码验证 */
    var validatePassTrigger = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.password_again !== "") {
          this.$refs.ruleForm.validateField("password_again");
        }
        callback();
      }
    };
    /* 密码确认验证 */
    var validatePass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    /* 获取账号验证 */
    var validateNumber = (rule, value, callback) => {
      let self = this;
      if (
        value != "" &&
        this.form.name != "" &&
        this.form.idcard != "" &&
        this.accountFlag
      ) {
        LYCom.AsynCallBiz(
          function (e) {
            if (e.err) {
            } else {
              self.form.login_name = e.rtnObj;
              callback();
            }
          },
          "SchoolMgrBiz.AutoAccount",
          self.form.name,
          self.form.idcard
        );
      }
    };
    return {
      passwordFlag: false,
      passwordAgainFlag: false,
      dialogVisible: false,
      accountFlag: true,
      provinceList: [], //省份
      cityList: [], //城市
      countyList: [], //区县
      schoolList: [], //学校列表
      gradeList: [], //年级列表
      classList: [], //班级列表
      checked: false,
      form: {
        province: "", //省份
        city: "", //城市
        county: "", //区县
        school_id: null, //学校
        grade_id: null, //年级
        class_id: null, //班级
        name: "", //姓名
        login_name: "", //账号
        password: "123456", //密码
        password_again: "", //确认密码
        idcard: "", //身份证号
        sex: null, //性别
        age: null,
        birthday: "",
        contact: "",
        address: "",
      },
      formRules: {
        province: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
        school_id: [
          { required: true, message: "请选择所属学校", trigger: "blur" },
        ],
        /* 姓名 */
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateNumber, required: true, trigger: "blur" },
        ],
        login_name: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        password: [
          { validator: validatePassTrigger, required: true, trigger: "blur" },
        ],
        password_again: [
          { validator: validatePass, required: true, trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        age: [{ required: true, message: "请输入年龄", trigger: "change" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        // contact: [
        //   { required: true, message: "请输入联系方式", trigger: "blur" },
        // ],
        /* 身份证号 */
        idcard: [
          { validator: validateCode, trigger: "blur", required: true },
          { validator: validateNumber, required: true, trigger: "blur" },
        ],
      },
      //性别列表
      genderList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
    };
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    // registerUser1(formName) {
    //   let self = this;
    //   let student_info = self.form;
    //   self.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       console.log(123456);
    //       if (!self.checked) {
    //         self.$message.error("请仔细阅读协议并勾选");
    //         return;
    //       }
    //         LYCom.AsynCallBiz(
    //         function (e) {
    //           if (e.err) {
    //             self.$message.error("注册失败, ");
    //           } else {
    //             if (e.rtnObj.success) {
    //               self
    //                 .$confirm("是否跳转到登录界面？", "注册成功！")
    //                 .then(() => {
    //                   self.$router.push({
    //                     name: "login",
    //                   });
    //                 })
    //                 .catch((_) => {});
    //             } else {
    //               console.log(err);
    //               self.$message.error(e.errmsg);
    //             }
    //           }
    //         },
    //         "SchoolMgrBiz.StudentRegistration",
    //         student_info
    //       );
    //     }else{
    //          return false;
    //     }
    //   });
    // },
    /* 注册用户 */
    registerUser(formName) {
      let self = this;
      let student_info = self.form;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          if (!self.checked) {
            self.$message.error("请仔细阅读协议并勾选");
            return;
          }
          /* 提交信息 */
          LYCom.AsynCallBiz(
            function (e) {
              if (e.err) {
                self.$message.error("注册失败, ");
              } else {
                if (e.rtnObj.success) {
                  self
                    .$confirm("是否跳转到登录界面？", "注册成功！")
                    .then(() => {
                      self.$router.push({
                        name: "login",
                      });
                    })
                    .catch((_) => {});
                } else {
                  self.$message.error(e.errmsg);
                }
              }
            },
            "SchoolMgrBiz.StudentRegistration",
            student_info
          );
        } else {
          return false;
        }
      });
    },
    // 省份切换
    provinceChange() {
      this.form.city = null;
      this.form.county = null;
      this.form.school_id = null;
      this.form.grade_id = null;
      this.form.class_id = null;
      this.cityList = [];
      this.countyList = [];
      this.schoolList = [];
      this.gradeList = [];
      this.classList = [];
      this.getCityList();
    },
    // 城市切换
    cityChange() {
      this.form.county = null;
      this.form.school_id = null;
      this.form.grade_id = null;
      this.form.class_id = null;
      this.countyList = [];
      this.schoolList = [];
      this.gradeList = [];
      this.classList = [];
      this.getCountList();
    },
    // 学校切换
    schoolChange() {
      this.gradeList = [];
      this.classList = [];
      this.form.grade_id = null;
      this.form.class_id = null;
      this.getGradeList();
    },
    // 区县切换，获取学校
    countyChange() {
      console.log(123);
      this.form.school_id = null;
      this.form.grade_id = null;
      this.form.class_id = null;
      this.schoolList = [];
      this.gradeList = [];
      this.classList = [];
      this.getSchoolList(this.form.county);
    },
    // 年级切换
    gradeChange() {
      this.form.class_id = null;
      this.classList = [];
      this.getClassList();
    },
    // 获取省份列表
    getProvinceList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取省级数据错误, " + e.err);
          } else {
            if (e.rtnObj) {
              self.provinceList = e.rtnObj;
            } else {
              self.provinceList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        null,
        1
      );
    },
    // 获取城市
    getCityList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取城市数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.cityList = e.rtnObj;
            } else {
              self.cityList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        self.form.province,
        2
      );
    },
    // 获取班级
    getClassList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取班级数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.classList = e.rtnObj;
            } else {
              self.classList = [];
            }
          }
        },
        "SchoolMgrBiz.GetClassByGradeIdNoToken",
        self.form.grade_id
      );
    },
    // 获取区县
    getCountList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取区县数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              // console.log(123456)
              self.countyList = e.rtnObj;
            } else {
              // console.log('这是只有二级的菜单')
              // console.log(self.form.city)
              self.getSchoolList(self.form.city);
              self.countyList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        self.form.city,
        3
      );
    },
    // 获取学校
    getSchoolList(id) {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取学校数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.schoolList = e.rtnObj;
            } else {
              self.schoolList = [];
            }
          }
        },
        "SchoolMgrBiz.GetSchoolListByAreaIdNoToken",
        id
        // self.form.county
      );
    },
    // 获取年级
    getGradeList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取班级数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.gradeList = e.rtnObj;
            } else {
              self.gradeList = [];
            }
          }
        },
        "SchoolMgrBiz.GetGradeListBySchoolIdNoToken",
        self.form.school_id
      );
    },

  },
};
</script>

<style scoped lang='less'>
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/header_bg.jpg);
  z-index: 99;
  position: relative;
}
.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}
.footer {
  height: 60px;
  text-align: center;
  font-size: 13px;
  color: #999;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  a {
    font-size: 13px;
    color: #999999;
    text-decoration: none;
  }
}
.footer p {
  line-height: 20px;
}
.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}
.head_title {
  font-size: 24px;
}
.back-head {
  padding-top: 45px;
  line-height: 100%;
}
.warp {
  width: 980px;
  margin: 0 auto;
}
.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}
.back-head p {
  margin: 15px 0 45px;
  font-size: 16px;
  color: #333;
}
.content .warp {
  background: url(/static/images/container_bg.png) repeat-y;
  padding: 0 4px 0 100px;
}
.area_list {
  display: flex;
  width: 675px;
}
.idcard_list {
  display: flex;
  justify-content: space-between;
  width: 774px;
}
.idcard_list .el-form-item {
  width: 50%;
}
.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}
.class_warp {
  width: 675px;
  display: flex;
}
.checked-box {
  width: 774px;
  text-align: center;
}
.next {
  width: 774px;
  text-align: center;
  margin-top: 10px;
}
.agreementText {
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
}
.agreementText:hover {
  color: #091d7c;
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/registeredNumber.vue